import { usePathname } from 'next/navigation';

import { SeoFamillies } from '~/src/common/components/Seo/SeoFamilies';
import { useScreenSize } from '~/src/common/hooks/useScreenSize';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag/client';
import I18n from '~/src/common/services/I18n';
import { isHomePathname } from '~/src/common/utils/home';
import { useNavigation } from '~/src/queries/api-ecom/generated/api-ecom';

import { NavigationSource, NavigationTrackingProvider } from '../tracking';

import * as NewStyles from './layout';
import * as OldStyles from './layout-old';

interface Props {
  source?: NavigationSource;
  noTitle?: boolean;
}

const Navigation = ({ source }: Props) => {
  const isFamiliesVisibleOnMobile = useFeatureFlag('show-families-home-mobile');
  const pathname = usePathname();
  const isHome = isHomePathname(pathname);
  const size = useScreenSize();
  const { data } = useNavigation();

  const S = isFamiliesVisibleOnMobile ? { ...NewStyles } : { ...OldStyles };

  if (!size.isLargeScreen && !isHome) return <SeoFamillies />;

  /**
   * Le titre est dessous en desktop mais au dessus en mobile.
   * Le position sticky ne permet pas de creer un composant au niveau superieur qui aurait un flex reverse.
   */
  const Title = isHome ? <S.Title>{I18n.t('common.family-header')}</S.Title> : null;

  if (!isFamiliesVisibleOnMobile)
    return (
      <NavigationTrackingProvider navigation={data} source={source}>
        <S.Container>
          {Title}
          {data == null ? <S.Placeholder /> : <S.Families families={data.families} />}
        </S.Container>
      </NavigationTrackingProvider>
    );

  return (
    <NavigationTrackingProvider navigation={data} source={source}>
      {!size.isLargeScreen && Title}
      {data == null ? <S.Placeholder /> : <S.Families families={data.families} />}
      {size.isLargeScreen && Title}
    </NavigationTrackingProvider>
  );
};

export default Navigation;
